// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"132":"9287ba43","354":"49316066","418":"36fd0f22"}[chunkId] + ".js";
};